module.exports = __webpack_public_path__ + "img/ic-arrow-down-black.ec0aeff1.svg";